import script from "./DeliveryCountryModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryCountryModal.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryCountryModal.vue?vue&type=style&index=0&id=d772b2ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d772b2ec"]])

export default __exports__